import { Grid, Typography, Box } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import { selectFieldStyles, textFieldStyles } from 'quoting/new-quote/helpers';
import { us_and_canada_states, US_State } from 'shared/constants';
import { FormTextField, SelectField } from 'shared/controls';
import { useQueryQuoteBrands } from 'shared/queries';

export const WholesalerInfo = () => {
  const {
    formState: { errors },
    getValues,
  } = useFormContext();
  const { brandsOptions, isFetching, isLoading } = useQueryQuoteBrands();

  return (
    <Grid item xs={12} md={6}>
      <Typography mb={1} variant='h6'>
        Brand
      </Typography>
      <Box sx={{ marginTop: 1 }}>
        <SelectField
          name='brand'
          label='Brand *'
          options={brandsOptions || []}
          loading={isFetching || isLoading}
          getOptionLabel={opt => opt}
          isOptionEqualToValue={(option, value) => {
            if (!option || !value) return true;
            return option === value;
          }}
          rules={{ validate: (value: string) => getValues('status') === 'DRAFT' || !!value || 'Brand is required' }}
          error={Boolean(errors?.brand)}
          helperText={errors?.brand?.message}
          sx={selectFieldStyles}
        />
      </Box>
      <Typography mb={1} mt={1} variant='h6'>
        Wholesaler Information
      </Typography>
      <FormTextField sx={textFieldStyles} name='wholesaler' label='Wholesaler' />
      <Box sx={{ marginTop: 1 }}>
        <FormTextField sx={textFieldStyles} name='wholesalerCustomerNumber' label='Customer Number' />
      </Box>
      <Box sx={{ marginTop: 1 }}>
        <FormTextField sx={textFieldStyles} name='wholesalerCity' label='City' />
      </Box>
      <Box sx={{ marginTop: 1 }}>
        <SelectField<US_State>
          name='wholesalerState'
          label='State'
          options={us_and_canada_states.sort((p1, p2) => (p1.name > p2.name ? 1 : p1.name < p2.name ? -1 : 0))}
          getOptionLabel={us_state => us_state.name || ''}
          isOptionEqualToValue={(option, value) => {
            if (!option || !value) return true;
            return option.name === value.name;
          }}
          sx={selectFieldStyles}
        />
      </Box>
      <Box sx={{ marginTop: 1 }}>
        <FormTextField
          sx={textFieldStyles}
          name='wholesalerContact'
          label='Contact - Requested By'
          helperText={errors?.wholesalerContact?.message}
        />
      </Box>
      <Box sx={{ marginTop: 1 }}>
        <FormTextField
          sx={textFieldStyles}
          name='wholesalerEmail'
          label='E-mail'
          helperText={errors?.wholesalerEmail?.message}
        />
      </Box>
      <Box sx={{ marginTop: 1 }}>
        <FormTextField
          sx={textFieldStyles}
          name='wholesalerPhone'
          label='Phone'
          helperText={errors?.wholesalerPhone?.message}
        />
      </Box>
    </Grid>
  );
};
